import { Button, ButtonProps } from "./button.js";
import { ToggleButton, ToggleButtonProps } from "./toggleButton.js";
import { Helper } from "../util/helper.js";
import React from "react";
interface ToggleButtonGroupProps extends React.PropsWithChildren { style?: React.CSSProperties }
export class ToggleButtonGroup extends React.Component<ToggleButtonGroupProps, any>{

    constructor(props) {
        super(props);
    }


    private _lastNotNullIndex = () => {
        let c = React.Children.count(this.props.children) - 1;

        if (c === 0) {
            if (Helper.hasValue(this.props.children)) {
                return 0;
            }
        } else {
            for (let i = c; i >= 0; i--) {
                if (Helper.hasValue(this.props.children[i])) {
                    return i;
                }
            }
        }

        return -1;
    }

    private _processButton = (btn: any, last: boolean) => {
        return React.cloneElement(btn, { isInGroup: true, isLastInGroup: last } as ButtonProps);
    }

    private _processToggleButton = (btn: any, last: boolean) => {
        return React.cloneElement(btn, { isInGroup: true, isLastInGroup: last } as ToggleButtonProps);
    }

    private _process = (btn: any, idx: number, lastNotNulIdx: number) => {
        if (Helper.hasValue(btn)) {
            if (btn.type === Button) {
                return this._processButton(btn, idx === lastNotNulIdx);
            } else if (btn.type === ToggleButton) {
                return this._processToggleButton(btn, idx === lastNotNulIdx);
            }
        }

        return btn;
    }


    render() {
        const lastIdx = this._lastNotNullIndex();
        return (
            <div style={this.props.style} className="toggle-button-group">
                {React.Children.map(this.props.children, (c, i) => this._process(c, i, lastIdx))}
            </div>
        );
    }
}